import { prop, applySpec, nthArg } from 'ramda';
import { createSelector } from 'reselect';
import { getMerchantProp } from 'modules/user/selectors/merchant';
import { getName, getEmail } from 'modules/user/selectors/user';
import { mapPlans, mapPlansDataToMap } from 'modules/pricing/helpers';
import plans from './plans';

export const getModals = (state) => state.pricing.ui.modals

export const getPlans = createSelector(
  getMerchantProp('plan'),
  mapPlans(plans.data),
)

export const getLastInactiveCell = createSelector(
  getMerchantProp('plan'),
  (plan) => mapPlansDataToMap(plans.data)[plan],
)

export const getCurrentPlanType = (_, { data }) => data.planType;

export const getCurrentPlan = createSelector(
  getCurrentPlanType,
  (type) => plans.data.find(({ type: t }) => (
    t === type
  ))
)

export const getCurrentPlanName = createSelector(
  getCurrentPlan, prop('name')
)

export const getCurrentPlanPrice = createSelector(
  getCurrentPlan, prop('price')
)

export const getInitialContactValues = createSelector(
  getMerchantProp('merchantName'),
  getName,
  getEmail,
  (url, name, email) => ({ url, email, name })
)
